import React, { useEffect } from 'react';
import Loading from 'components/Loading';
import ErrorBox from 'components/ErrorBox';
import Title from 'components/Title';
import ui from 'stores/ui';
import withSSR, { SSRProps } from 'utils/withSSR';

import store from './store';

import './style.scss';

const Disclaimers: React.FC<SSRProps<{
    data: any;
}>> = props => {
    useEffect(() => {
        ui.setPid('disclaimers');
    }, []);

    function render() {
        if (props.__loading__) {
            return <Loading tip={'loading...'} />;
        }

        if (props.__error__) {
            return <ErrorBox error={props.__error__} />;
        }

        if (!props.data) {
            return <div className="text-center">Sorry, this content isn't available right now</div>;
        }

        return (
            <div className="a-flyRightIn">
                <div dangerouslySetInnerHTML={{ __html: props.data }} />
            </div>
        );
    }

    return (
        <div className="page-disclaimers">
            <Title title="Disclaimers" />
            <div className="site-main">{render()}</div>
        </div>
    );
};

export default withSSR(Disclaimers, async () => {
    const data = await store.getDisclaimers();

    return {
        data
    };
});
